// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"f61b7687","787":"bcc65c43","850":"28b325b4"}[chunkId] + ".chunk.js";
};